import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TableModule } from 'primeng/table';
import { ToggleSwitchChangeEvent } from 'primeng/toggleswitch';
import { InputFileComponent } from '@shared/components/form-elements/input-file/input-file.component';
import { FormControl } from '@angular/forms';
import { ButtonComponent } from '@shared/components/button/button.component';
import { SwitcherComponent } from '@shared/components/form-elements/switcher/switcher.component';
import { BehaviorSubject } from 'rxjs';
import { ImportErrorComponent } from '@b2b/components/cart/cart-import/components/import-error/import-error.component';
import { ImportProductsComponent } from '@b2b/components/cart/cart-import/components/import-products/import-products.component';
import { inputValidator } from '@b2b/features/cart/helpers/import-validators';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'cart-import',
  imports: [
    CommonModule,
    RouterModule,
    TableModule,
    ButtonComponent,
    SwitcherComponent,
    InputFileComponent,
    ImportErrorComponent,
    ImportProductsComponent,
    TranslateModule,
  ],
  templateUrl: './cart-import.component.html',
  styleUrl: './cart-import.component.scss',
})
export class CartImportComponent {
  switch$ = new BehaviorSubject({
    id: 'enable-substitute',
    label: 'Substituir itens no meu carrinho atual',
    enabled: false,
  });

  fileControl = new FormControl(null, {
    validators: [inputValidator()],
  });

  eanControl = new FormControl(null, {
    validators: [inputValidator()],
  });
  quantityControl = new FormControl(null, {
    validators: [inputValidator()],
  });

  control = new FormControl(null, {
    validators: [inputValidator()],
  });

  constructor() {}

  onCheck(event: ToggleSwitchChangeEvent) {
    if (event.checked) {
      this.switch$.next({
        ...this.switch$.getValue(),
        enabled: true,
      });
    } else {
      this.switch$.next({
        ...this.switch$.getValue(),
        enabled: false,
      });
    }
  }
}
